import { TourConfig, TourHandle, useFeatureTour } from '@app/core/tours/useFeatureTour';
import { defineMessage, useIntl } from 'react-intl';

/** ID of the Paper element highlighted by the segmentation editor tour. */
export const SEGMENTATION_EDITOR_TOUR_ELEMENT_ID = 'report-definition-segmentation-editor';

/**
 * Runs the one-time tour for the report definition segmentation editor if not yet seen and before expiry.
 */
export function useSegmentationEditorTour(): TourHandle {
  const { $t } = useIntl();

  return useFeatureTour({ key: 'reportDefinitionSegmentationEditor', expiry: '2026-03-30' }, {
    steps: [
      {
        element: `#${SEGMENTATION_EDITOR_TOUR_ELEMENT_ID}`,
        popover: {
          title: $t(
            defineMessage({
              id: 'audit.reportDefinitions.segmentation.tour.title',
              defaultMessage: 'Segmentación del reporte',
            }),
          ),
          description: $t(
            defineMessage({
              id: 'audit.reportDefinitions.segmentation.tour.description',
              defaultMessage:
                'Activá esta opción para dividir el reporte en secciones (por ejemplo, una hoja XLS por cada valor de la columna elegida).',
            }),
          ),
          side: 'top',
          align: 'center',
        },
      },
    ],
  } satisfies TourConfig);
}
